import ComparisonPreview from '@app/Comparison/Preview'
import AddToComparison from '@app/Comparison/Add'

const ComparisonList = () => import('@app/Comparison/List')
const ComparisonView = () => import('@app/Comparison/View')
const ProductView = () => import('@app/Comparison/ProductView')

export default function plugin(Vue) {
  Vue.component(ComparisonPreview.name, ComparisonPreview)
  Vue.component('AddToComparison', AddToComparison)
  Vue.component('ComparisonList', ComparisonList)
  Vue.component('ComparisonView', ComparisonView)
  Vue.component('ComparisonProductView', ProductView)
}
